import axios from '../../axios';
import * as TYPES from '../types';

const state = {
  tasks: [],
  taskDetail: null,
  tracking: [],
};
const getters = {
  tasks: state => state.tasks,
  taskDetail: state => state.taskDetail,
  tracking: state => state.tracking,
};
const mutations = {
  [TYPES.SET_TASKS](state, payload) {
    state.tasks = payload;
  },
  [TYPES.SET_TASK_DETAIL](state, payload) {
    state.taskDetail = payload;
  },
  [TYPES.SET_TRACKING](state, payload) {
    state.tracking = payload;
  },
};
const actions = {
  /**
   * 获取待办列表
   * @param commit
   */
  getTasks: ({commit}) => {
    commit(TYPES.SET_LOADING, true);
    axios
      .get("/tasks",{params:{sort:'createDate,desc'}})
      .then(response => {
        commit(TYPES.SET_TASKS, response.data.data);
        commit(TYPES.SET_LOADING, false);
      })
      .catch(reason => {
        commit(TYPES.SET_ERROR, reason.message);
        commit(TYPES.SET_LOADING, false);
      });
  },

  /**
   * 获取物流信息
   * @param commit
   * @param taskId
   */
  getTracking: ({commit}, taskId) => {
    commit(TYPES.SET_TRACKING, []);
    commit(TYPES.SET_LOADING, true);
    axios
      .get("/tasks/" + taskId + '/tracking')
      .then(response => {
        commit(TYPES.SET_TRACKING, response.data.routes);
        commit(TYPES.SET_LOADING, false);
      })
      .catch(reason => {
        commit(TYPES.SET_ERROR, reason.message);
        commit(TYPES.SET_LOADING, false);
      });
  },

  /**
   * 获取待办详情
   * @param commit
   * @param taskId
   */
  getTaskDetail: ({commit}, taskId) => {
    commit(TYPES.SET_TASK_DETAIL, null);
    commit(TYPES.SET_LOADING, true);
    axios
      .get("/tasks/" + taskId)
      .then(response => {
        commit(TYPES.SET_TASK_DETAIL, response.data);
        commit(TYPES.SET_LOADING, false);
      })
      .catch(reason => {
        commit(TYPES.SET_ERROR, reason.message);
        commit(TYPES.SET_LOADING, false);
      });
  },

  /**
   * 提交待办事项
   * @param commit
   * @param item
   * @param cb
   */
  saveTask: ({commit}, {item, cb}) => {
    //验证
    if (!item.companyId) {
      commit(TYPES.SET_ERROR, '请选择公司');
      return;
    }
    if (!item.description) {
      commit(TYPES.SET_ERROR, '事项描述不能为空');
      return;
    }

    commit(TYPES.SET_LOADING, true);
    axios
      .post("/tasks", item)
      .then((res) => {
        commit(TYPES.SET_LOADING, false);
        commit(TYPES.SET_ERROR, '创建成功');
        if (cb) {
          cb(res);
        }
      })
      .catch(reason => {
        commit(TYPES.SET_ERROR, reason.response.data.message);
        commit(TYPES.SET_LOADING, false);
      });
  },

  /**
   * 删除待办事项
   * @param commit
   * @param dispatch
   * @param taskId
   */
  deleteTask: ({commit, dispatch}, taskId) => {
    commit(TYPES.SET_LOADING, true);
    axios
      .post("/tasks/delete", {
        taskIds: Array.of(taskId)
      })
      .then(() => {
        commit(TYPES.SET_LOADING, false);
        commit(TYPES.SET_ERROR, '删除成功');

        dispatch('getTasks');
      })
      .catch(reason => {
        commit(TYPES.SET_ERROR, reason.response.data.message);
        commit(TYPES.SET_LOADING, false);
      });
  },

  /**
   * 确认物流信息
   * @param commit
   * @param dispatch
   * @param taskId
   * @param cb
   */
  confirmDelivery: ({commit, dispatch}, {taskId,cb}) => {
    commit(TYPES.SET_LOADING, true);
    axios
      .post("/tasks/" + taskId + "/confirm-delivery")
      .then(() => {
        // commit(TYPES.SET_LOADING, false);
        // commit(TYPES.SET_ERROR, '提交成功');

        //dispatch('finishTask');
        cb();
      })
      .catch(reason => {
        commit(TYPES.SET_ERROR, reason.response.data.message);
        commit(TYPES.SET_LOADING, false);
      });
  },

  /**
   * 完成待办事项
   * @param commit
   * @param dispatch
   * @param item
   * @param cb
   */
  finishTask: ({commit, dispatch}, {item, cb}) => {
    commit(TYPES.SET_LOADING, true);
    item.progress = '已完成';
    axios
      .put("/tasks/" + item.taskId, item)
      .then(() => {
        commit(TYPES.SET_LOADING, false);
        //commit(TYPES.SET_ERROR, '提交成功');

        dispatch('getTaskDetail',item.taskId);
        cb();
      })
      .catch(reason => {
        commit(TYPES.SET_ERROR, reason.response.data.message);
        commit(TYPES.SET_LOADING, false);
      });
  },
};

export default {
  state,
  getters,
  mutations,
  actions
}